import featureFlags from 'common/helpers/featureFlags';
import { ReportingApiClient } from '../../services/httpClient';

const baseServicePath = (projectId, contentId, versionStatus, isTopic) => {
  let servicePath = '';
  if (isTopic) {
    // According Back-end team we should use for now 'KeyFocusArea' as the endpoint for topics,
    // they will change it in the feature.
    servicePath = [
      'v2',
      'projects',
      projectId,
      'preview',
      'content',
      contentId,
      versionStatus,
      'KeyFocusArea',
    ].join('/');
  } else {
    servicePath = (
      featureFlags.isP3Enabled
        ? [
            'v2',
            'projects',
            projectId,
            'preview',
            'content',
            contentId,
            versionStatus,
            'KeyFocusArea',
          ]
        : [
            'projects',
            projectId,
            'preview',
            'content',
            contentId,
            versionStatus,
          ]
    ).join('/');
  }

  return servicePath;
};

export const getReportPreview = async (
  projectId,
  contentId,
  version,
  cancelRequestFn = undefined,
  isTopic = false
) => {
  const response = await ReportingApiClient.get(
    baseServicePath(projectId, contentId, version, isTopic),
    undefined,
    undefined,
    cancelRequestFn
  );

  return response.data.previewImage;
};
